import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { CreateEmployeeDialog } from "../details/employee/CreateEmployeeDialog";
import { useDialog } from "../hooks/useDialog";

export function AddEmployeeButton() {
  const { openDialog, isDialogOpen, dialogProps } = useDialog();

  return (
    <>
      <Button startIcon={<AddIcon />} variant="outlined" size="small" onClick={openDialog}>
        Hinzufügen
      </Button>
      {isDialogOpen && <CreateEmployeeDialog {...dialogProps} />}
    </>
  );
}
